export const LANG_STORAGE_KEY = 'app:lang';

export type AppLanguage = 'en' | 'tr';

export const SUPPORTED_LANGUAGES: readonly AppLanguage[] = ['en', 'tr'] as const;
export const DEFAULT_LANGUAGE: AppLanguage = 'en';

export function normalizeLanguage(input?: string | null): AppLanguage {
  const raw = (input ?? '').toLowerCase();
  if (raw === 'tr' || raw.startsWith('tr-')) return 'tr';
  if (raw === 'en' || raw.startsWith('en-')) return 'en';
  return DEFAULT_LANGUAGE;
}

export function readStoredLanguage(): AppLanguage | null {
  try {
    const v = window.localStorage.getItem(LANG_STORAGE_KEY);
    if (!v) return null;
    return normalizeLanguage(v);
  } catch {
    return null;
  }
}

export function writeStoredLanguage(lang: AppLanguage) {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    // ignore storage errors (private mode, blocked, etc.)
  }
}

